import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import qs from 'qs';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import ModalManager from '../modal/modal-manager';
import RemoveUser from '../modal/remove-modal';
import Filter from '../../../components/filter/filter.jsx';
import { removeMembers } from '../../api/clazz';


import styles from './user-list.css';

const messages = defineMessages({
    filterPlaceholder: {
        id: 'gui.library.filterPlaceholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for library search field'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }
});

class UserList extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleFilterChange',
            'handleFilterClear',
            'handlePlayingEnd',
            'handleSelect',
            'setFilteredDataRef'
        ]);
        this.query = qs.parse(this.props.history.location.search,{ ignoreQueryPrefix: true })
        this.state = {
            playingItem: null,
            filterQuery: ''
        };
    }
    componentDidMount() {
        // Allow the spinner to display before loading the content
        if (this.props.setStopHandler) this.props.setStopHandler(this.handlePlayingEnd);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterQuery !== this.state.filterQuery) {
            this.scrollToTop();
        }
    }
    handleSelect(index) {
        //this.handleClose();
        this.props.onItemSelected(this.getFilteredData()[index]);
    }
    handleClose() {
        this.props.onRequestClose();
    }

    handlePlayingEnd() {
        if (this.state.playingItem !== null) {
            this.setState({
                playingItem: null
            });
        }
    }
    handleFilterChange(event) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: event.target.value,
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: event.target.value,
                playingItem: null,
            });
        }
    }
    handleFilterClear() {
        this.setState({ filterQuery: '' });
    }
    getFilteredData() {
        if (!this.state.filterQuery) return this.props.data;
        return this.props.data.filter(dataItem => (
            ([])
                // Second argument to map sets `this`
                .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                .concat(dataItem.name ?
                    (typeof dataItem.name === 'string' ?
                        // Use the name if it is a string, else use formatMessage to get the translated name
                        dataItem.name : this.props.intl.formatMessage(dataItem.name.props)
                    ).toLowerCase() :
                    null)
                .join('\n') // unlikely to partially match newlines
                .indexOf(this.state.filterQuery.toLowerCase()) !== -1
        ));
    }
    scrollToTop() {
        this.filteredDataRef.scrollTop = 0;
    }
    setFilteredDataRef(ref) {
        this.filteredDataRef = ref;
    }


    handleRemove(e, id) {
        e.stopPropagation();
        ModalManager.open(RemoveUser, {
            title: '移除学生',
            onClose: () => { },
            onSubmit: () => {
                const res = removeMembers({ clazz_id: this.query.id,user_id:id })
                    if (res) {
                        ModalManager.pop()
                       this.props.onRemove()
                    }
            },
            content: '确认要移除当前学生吗？'
        })
    }

    render() {
        const { title, type, identity } = this.props
        return (
            <div dir={this.props.isRtl ? 'rtl' : 'ltr'}>
                <div className={styles.userBox} ref={this.setFilteredDataRef}>
                    <div className={styles.title}>
                        <div>{title}</div>
                        <div className={styles.filterBar}>
                            <Filter
                                className={classNames(
                                    styles.filterBarItem,
                                    styles.filter
                                )}
                                filterQuery={this.state.filterQuery}
                                inputClassName={styles.filterInput}
                                placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
                                onChange={this.handleFilterChange}
                                onClear={this.handleFilterClear}
                            />
                        </div>
                    </div>
                    <div className={styles.memberBox}>
                        {
                            this.getFilteredData().length > 0 ? (
                                this.getFilteredData().map((item, index) => (
                                    <div className={styles.userItem} key={item.id} onClick={()=>this.handleSelect(index)}>
                                        <div className={styles.userContent}>
                                            <img src={`${window.config.staticURL}/avatar/${item.avatar || "default.png"}`}></img>
                                            <div className={styles.username}>
                                                {type === 'rank' && <p>NO.{index + 1}</p>}
                                                <span>{item.name}</span>
                                            </div>
                                        </div>
                                        <div className={styles.differentShow}>
                                            {identity === 'teacher' ? (
                                                <span className={styles.deleteBtn} onClick={(e) => this.handleRemove(e, item.id)}>移除</span>
                                            ) : type === 'rank' ? (
                                                <span>1234</span>
                                            ) : (
                                                <span></span>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ padding: '8px 24px' }}>{window.L('teach.class.noMember')}</div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

UserList.propTypes = {
    projectId: PropTypes.number,
    allowDelete: PropTypes.bool,
    data: PropTypes.arrayOf(
        /* eslint-disable react/no-unused-prop-types, lines-around-comment */
        // An item in the library
        PropTypes.shape({
            // @todo remove md5/rawURL prop from library, refactor to use storage
            md5: PropTypes.string,
            name: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node
            ]),
            rawURL: PropTypes.string
        })
        /* eslint-enable react/no-unused-prop-types, lines-around-comment */
    ),
    filterable: PropTypes.bool,
    intl: intlShape.isRequired,
    onItemSelected: PropTypes.func,
    onRequestClose: PropTypes.func,
    setStopHandler: PropTypes.func,
    title: PropTypes.string.isRequired,
    onRemove: PropTypes.func
};

UserList.defaultProps = {
    filterable: true
};

export default injectIntl(UserList);
